import { IDialogTexts } from "@saleor/components/PromptDialog/types";

export const PROMPT_DIALOG_TEXTS: IDialogTexts = {
  title: "You are removing an unlock code(s)",
  subTitle:
    "Any user with the removed unlock code is incapable of redeeming the coupon.",
  proceedButtonText: "Proceed Removal",
  cancelButtonText: "Retain"
};
